import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';
import { LocalizedComponentProps } from 'bernie-l10n';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { ImageViewModel, PhotoViewModel } from 'models/common';

import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';

import { GalleryDialog } from 'components/infosite/property-details/gallery-dialog';
import { LazyImage } from 'components/common/lazy/lazy-image';

export interface ReviewGalleryProps extends LocalizedComponentProps {
  photos?: PhotoViewModel[];
  reviewId?: string;
  analytics?: AnalyticsStore;
  routeStore?: RouteStore;
  currentHotel?: CurrentHotelStore;
}

export interface ReviewGalleryState {
  currentGalleryId: string;
  currentGalleryImages: any[];
  currentGalleryIndex: number;
  currentGalleryRef?: any;
}

@inject('analytics', 'routeStore', 'currentHotel')
@observer
export class ReviewGallery extends React.Component<ReviewGalleryProps, ReviewGalleryState> {
  private NO_OP = () => null;

  public constructor(props) {
    super(props);

    this.state = {
      currentGalleryId: '',
      currentGalleryImages: [],
      currentGalleryIndex: 0,
      currentGalleryRef: undefined
    };

    this.galleryDialogCloseCallback = this.galleryDialogCloseCallback.bind(this);
    this.updateIndex = this.updateIndex.bind(this);
  }

  public galleryDialogCloseCallback() {
    this.props.routeStore.goBack();

    this.focusGalleryRef(this.state.currentGalleryRef);
  }

  public focusGalleryRef(curGalRef) {
    if (curGalRef && curGalRef.current && typeof curGalRef.current.focus === 'function') {
      curGalRef.current.focus();
    }
  }

  private setGalleryAndIndex(reviewId, gallery, index, ref) {
    const { routeStore, analytics } = this.props;

    this.setState(
      {
        currentGalleryId: reviewId,
        currentGalleryImages: gallery,
        currentGalleryIndex: index,
        currentGalleryRef: ref
      },
      () => {
        routeStore.updateSearch({ pwaDialogNested: `review-images-${reviewId}` });

        analytics.clickTracker('.LaunchReviewPhotoGallery', 'Launch Photo Gallery From Image Click', null, this.NO_OP)();
      }
    );
  }

  public updateIndex(index) {
    this.setState({ currentGalleryIndex: index });
  }

  public render() {
    const { photos, reviewId } = this.props;
    const { currentGalleryId, currentGalleryImages, currentGalleryIndex } = this.state;
    const gallery = photos.map(image => ({ src: image.normalUrl }));

    return (
      <>
        <div className="uitk-grid all-cell-1-4 all-grid-nowrap all-x-gutter-two all-b-padding-two uitk-scroll-horizontal">
          {gallery.map((image: ImageViewModel, index) => {
            const buttonRef = React.createRef();
            const onClickCb = () => this.setGalleryAndIndex(reviewId, gallery, index, buttonRef);

            return (
              <LazyImage key={`review-image-${reviewId}-photo-${index}`} altPlaceholderText={image.caption || ''} className="uitk-cell">
                <button className="uitk-cell" onClick={onClickCb} tabIndex={0}>
                  <UitkFigure className="review-gallery-image all-image-fit-cover" ratio={UitkFigureAspectRatioType.R4_3}>
                    <UitkImage alt={image.caption || ''} src={image.src} />
                  </UitkFigure>
                </button>
              </LazyImage>
            );
          })}
        </div>
        <QueryRoute query={{ pwaDialogNested: `review-images-${reviewId}` }}>
          <Layer id="hotel-review-gallery" onDismiss={this.galleryDialogCloseCallback}>
            <GalleryDialog
              currentIndex={currentGalleryIndex}
              galleryDialogCloseCallback={this.galleryDialogCloseCallback}
              galleryName={`review-gallery-${currentGalleryId}`}
              images={currentGalleryImages}
              onIndexChange={this.updateIndex}
              trackingRfrr={`.Review.Gallery.${currentGalleryId}.close`}
            />
          </Layer>
        </QueryRoute>
      </>
    );
  }
}
